require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./how-vet-tec-works.json") })
        }
      }, "path---how-vet-tec-works");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---how-vet-tec-works!./.cache/json/how-vet-tec-works.json
// module id = 1225
// module chunks = 231608221292675